var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-wrapper',{attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"space-y-4"},[_c('base-card',{attrs:{"title":"Import Saldo"}},[_c('form',{staticClass:"space-y-4",on:{"submit":function($event){$event.preventDefault();return _vm.onProcess.apply(null, arguments)}}},[_c('base-input',{attrs:{"label":"Pilih Saldo"}},[_c('base-select',{attrs:{"shadow":false,"expand":"","options":[
              {
                key: 'order_balance',
                label: 'Stockist',
                value: 'order_balance',
              },
              {
                key: 'order_debt_balance',
                label: 'Kurang Bayar Stockist',
                value: 'order_debt_balance',
              },
              {
                key: 'restock_balance',
                label: 'Restock',
                value: 'restock_balance',
              },
              {
                key: 'deposit_balance',
                label: 'Deposit',
                value: 'deposit_balance',
              },
              {
                key: 'overpayment_balance',
                label: 'Sisa Bayar',
                value: 'overpayment_balance',
              },
              {
                key: 'debt_balance',
                label: 'Kurang Bayar SC',
                value: 'debt_balance',
              },
            ]},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1),_c('base-button',{attrs:{"type":"submit","loading":_vm.loadingProcess.visible}},[_vm._v(_vm._s(_vm.loadingProcess.visible ? _vm.loadingProcessLabel : 'Proses'))])],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }